import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async ({ dataProcessId = '', ...data }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/data_process_tags`,
    data,
  )
}

export default { create }
